import type { ColumnsType } from "antd/es/table";

interface Product {
  ASIN: string;
  productTitle: string;
  sku: string;
  cogs: number;
  quantity: number;
}

export const columns: ColumnsType<Product> = [
  {
    title: "ASIN",
    dataIndex: "ASIN",
  },
  {
    title: "Product Title",
    dataIndex: "productTitle",
  },
  {
    title: "SKU",
    dataIndex: "sku",
  },
  {
    title: "COGS",
    dataIndex: "cogs",
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
  },
];

interface PurchaseOrder {
  orderNumber: string;
  supplierName: string;
  supplierId: string;
  status: string;
  orderDate: string;
  estimatedCompletionDate: string;
  actualCompletionDate: string;
  products: Product[];
}

const purchaseOrder1: PurchaseOrder = {
  orderNumber: "131111",
  supplierName: "Best Nutrition",
  supplierId: "id_123gwe",
  status: "Open",
  orderDate: "2025-05-10",
  estimatedCompletionDate: "2025-05-24",
  actualCompletionDate: "2025-04-19",
  products: [
    {
      ASIN: "BOD5MNJWR9",
      productTitle: "InoPro Teeth Whitening Strips 7 Treatments Kit",
      sku: "KJG85903G",
      cogs: 20.99,
      quantity: 10000,
    },
    {
      ASIN: "BOD5MNJW7",
      productTitle: "InoPro Natural Teeth Whitening Strips Kit 14...",
      sku: "KJG85903G",
      cogs: 49,
      quantity: 8000,
    },
  ],
};

const purchaseOrder2: PurchaseOrder = {
  orderNumber: "131112",
  supplierName: "Alpha Health",
  supplierId: "id_456xyz",
  status: "Completed",
  orderDate: "2025-04-15",
  estimatedCompletionDate: "2025-04-30",
  actualCompletionDate: "2025-04-28",
  products: [
    {
      ASIN: "BOD6MNJWR9",
      productTitle: "Alpha Pro Whitening Strips 5 Treatments",
      sku: "KJG12345A",
      cogs: 15.5,
      quantity: 5000,
    },
    {
      ASIN: "BOD6MNJW7",
      productTitle: "Alpha Natural Whitening Strips 10 Treatments",
      sku: "KJG12345B",
      cogs: 40,
      quantity: 6000,
    },
  ],
};

const purchaseOrder3: PurchaseOrder = {
  orderNumber: "131113",
  supplierName: "Bright Smile Co.",
  supplierId: "id_789abc",
  status: "Shipped",
  orderDate: "2025-03-10",
  estimatedCompletionDate: "2025-03-25",
  actualCompletionDate: "2025-03-20",
  products: [
    {
      ASIN: "BOD7MNJWR9",
      productTitle: "Bright Smile Teeth Whitening Strips 10 Treatments",
      sku: "KJG67890C",
      cogs: 22.99,
      quantity: 15000,
    },
    {
      ASIN: "BOD7MNJW7",
      productTitle: "Bright Smile Natural Whitening Kit 12 Treatments",
      sku: "KJG67890D",
      cogs: 45,
      quantity: 12000,
    },
  ],
};

export const purchasesOrder = [purchaseOrder1, purchaseOrder2, purchaseOrder3];
